import { __t } from '../i18n/t'

type PasswordForm = { password?: string; confirmPassword?: string }

/**
 * O Joi do POST /customers faz trim só no `password`; o `confirmPassword` chega cru e é
 * comparado com o password já aparado ('abcdef ' nos dois campos dava 400). O trim vai no
 * envio, e não no parse do input, para não comer espaço no meio enquanto a pessoa digita.
 */
export const trimCustomerPasswords = <T extends PasswordForm>(data: T): T => ({
  ...data,
  password: data.password?.trim(),
  confirmPassword: data.confirmPassword?.trim(),
})

/** Compara com o valor aparado, que é o que o backend vai enxergar. */
export const equalsPassword = (value: unknown, all?: PasswordForm): string | undefined =>
  String(value ?? '').trim() === String(all?.password ?? '').trim()
    ? undefined
    : __t('As senhas não conferem')

/** `required()` do react-admin aceita '   ', que o backend apara para '' e recusa. */
export const notBlank = (value: unknown): string | undefined =>
  value && !String(value).trim() ? __t('A senha não pode ter só espaços') : undefined
